import firebase from 'firebase/compat/app'
import UserService from '@/services/api/user.service'

export const AUTH_STATE = {
    GUEST: 'guest',
    ANONYMOUS: 'anonymous',
    REGISTERED: 'registered',
}

const resolveAuthState = (authStore) => {
    const firebaseUser = firebase.auth().currentUser
    const hasFirebaseUser = !!firebaseUser
    const isAnonymous =
        firebaseUser?.isAnonymous === true ||
        authStore?.user?.data?.isAnonymous === true

    if (!hasFirebaseUser && !authStore?.userId) {
        return AUTH_STATE.GUEST
    }
    if (isAnonymous) {
        return AUTH_STATE.ANONYMOUS
    }
    return AUTH_STATE.REGISTERED
}

export const createAnonymousUser = async (authStore) => {
    try {
        const response = await UserService.createAnonymousClient()
        if (response?.status === 200 || response?.status === 201) {
            const firebaseUser = firebase.auth().currentUser
            if (firebaseUser && authStore?.setUser) {
                authStore.setUser(firebaseUser)
            }
            if (authStore?.user) {
                authStore.user.data = response.data
            }
            return { success: true }
        }
    } catch (error) {
        console.error('Failed to create anonymous user:', error)
    }
    return { success: false }
}

export const ensureAnonymous = (authStore) => {
    const authState = resolveAuthState(authStore)
    if (authState === AUTH_STATE.GUEST) {
        return { pass: false, handler: 'create-anon' }
    }
    return { pass: true }
}

export const ensureRegistered = (authStore) => {
    const authState = resolveAuthState(authStore)
    if (authState === AUTH_STATE.REGISTERED) {
        return { pass: true }
    }
    return {
        pass: false,
        handler: 'show-auth-modal',
        reason: authState,
    }
}

export const ensureProfileSetup = (authStore) => {
    const user = authStore?.user?.data
    const displayname = user?.displayname

    const hasName =
        displayname &&
        displayname !== 'Anonymous' &&
        displayname.trim().length >= 2

    if (hasName) {
        return { pass: true }
    }
    if (!user) {
        return { pass: false, handler: 'create-anon' }
    }
    return { pass: false, handler: 'redirect-profile-setup' }
}

export const getAuthState = (authStore) => resolveAuthState(authStore)
